export const ProductType = {
    /** 기본 */
    NORMAL: 'NORMAL',
    /** 주류 포함 */
    ALCOHOL: 'ALCOHOL',
} as const

export const Status = {
    /** 비활성화 */
    INACTIVE: 'INACTIVE',
    /** 픽업 신청 */
    REQUEST: 'REQUEST',
    /** 픽업 대기 */
    WAIT: 'WAIT',
    /** 미수취 */
    UNRECEIVED: 'UNRECEIVED',
} as const

export interface PickupState {
    /** 판매처명 */
    merchantName: string
    /** 지점명 */
    branchName?: string
    /** 대기 시간 */
    waitTime?: number
    /** 픽업 코드 */
    code?: string
    /** 상품 타입 */
    productType: Constant<typeof ProductType>
    /** 픽업 상태 */
    status: Constant<typeof Status>
    /** 받을 사람 */
    receiver?: {
        /** 이름 */
        name: string
        /** 전화번호 */
        phoneNumber: string
        /** 안심번호 */
        virtualPhoneNumber?: string
        /** 수정 여부 */
        modified?: boolean
        /** 안심번호 사용 가능 여부 */
        supportVirtualNumber?: boolean
        /** 안심번호 사용 여부 */
        useVirtualNumber?: boolean
    }
    /** 위치 정보 */
    location: {
        /** 주소 */
        address: string
        /** 상세 주소 */
        subAddress?: string
        /** 우편번호 */
        zipCode?: string
        /** 장소 경도/위도 */
        point: {
            /** 경도 */
            x: string
            /** 위도 */
            y: string
        }
        /** 로고 URL */
        imageUrl: string
        /** 지도 위 마커 색상 */
        markerColor: string
    }
}

export type RootState = {pickup?: PickupState}
